import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const Verification = () => {

  const [verificationStatus, setVerificationStatus] = useState(null);
  const [mess, setMess] = useState('');
  const {uuid}  = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    axios.patch(`${apiUrl}/verification/mail`, {
      uuid: uuid
    })
    .then(response => {
      setVerificationStatus(response.data.success);
      setMess(response.data.message);
    })
    .catch(error => {
      setVerificationStatus(false);
    });
  }, [apiUrl, uuid]);

  return (
    <div>
      {verificationStatus === true && (
      <div id="alert-message" className="alert2" >
        <strong>{mess} </strong> <span id="alert-text"></span>
      </div>

      )}
      {verificationStatus === false && (
        <>
          <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong> Le lien de vérification est invalide ou a expiré. <span id="alert-text"></span>
          </div>
        </>
      )}
      {verificationStatus === null && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
      </div>
      )}
    </div>
  );
};

export default Verification;